import {
	addVoidForLinks,
	hamburger,
	viewPromoButton,
	setCityToCookie,
	menuOnMobile,
	profileSubmenu,
} from "./utils";
import eventObject from "./event";
import user from "./user";
import {verification} from "./verification";

const $ = window.jQuery;

$("html").removeClass("no-js");
addVoidForLinks($("a"));
hamburger("js-hamburger", "js-menu");
setCityToCookie();
menuOnMobile();
viewPromoButton();
user();
profileSubmenu();
verification.init();

eventObject.init();

$(".preloader").removeClass("active");

const purchaseItems = $(".purchase__item");

for (let i = 0; i < purchaseItems.length; i++) {
	const purchaseItem = $(purchaseItems[i]);
	const purchaseCheckboxes = purchaseItem.find(".js-purchase-checkbox");
	const purchaseClear = purchaseItem.find(".js-purchase-clear");
	const purchaseAll = purchaseItem.find(".js-purchase-all");
	purchaseClear.on("click", () => {
		purchaseCheckboxes.removeAttr("checked");
	});

	purchaseAll.on("click", () => {
		purchaseCheckboxes.attr("checked", true);
	});
}
